<template>
  <!-- Profile -->
  <router-link
    to="/account-admin/kyx"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">{{ MODULE_ICONS.kyx }}</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Políticas de KYX</h2>
        </div>
        <p class="text-gray-600 mt-1">
          Defina as regras e critérios para análise de risco e compliance cadastral.
        </p>
      </div>
    </div>
  </router-link>

  <!-- Monitoring -->
  <router-link
    to="/account-admin/monitoring"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-blue-100 p-3 rounded-full mr-4">
        <span class="material-icons text-blue-600 text-3xl">{{ MODULE_ICONS.pulse }}</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Políticas de PULSE</h2>
        </div>
        <p class="text-gray-600 mt-1">
          Configure o monitoramento contínuo de mudanças em entidades cadastradas.
        </p>
      </div>
    </div>
  </router-link>

  <!-- KYT -->
  <router-link
    v-if="canAccessKytConfig"
    to="/account-admin/kyt"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-indigo-100 p-3 rounded-full mr-4">
        <span class="material-icons text-indigo-600 text-3xl">{{ MODULE_ICONS.kyt }}</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Políticas de KYT</h2>
        </div>
        <p class="text-gray-600 mt-1">
          Gerencie as regras de monitoramento de transações financeiras.
        </p>
      </div>
    </div>
  </router-link>

  <!-- Role Management -->
  <router-link
    to="/account-admin/roles"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">verified_user</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Papéis</h2>
        </div>
        <p class="text-gray-600 mt-1">Gerencie os papéis e permissões da sua equipe.</p>
      </div>
    </div>
  </router-link>

  <!-- Transaction Platforms -->
  <router-link
    to="/account-admin/transactions-platforms"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">account_balance</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Plataformas</h2>
        </div>
        <p class="text-gray-600 mt-1">Configure as plataformas de origem para importação de transações.</p>
      </div>
    </div>
  </router-link>

  <!-- Type Management -->
  <router-link
    to="/account-admin/relationship-types"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">category</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Tipos de Relacionamento</h2>
        </div>
        <p class="text-gray-600 mt-1">Gerencie os tipos de relacionamento entre entidades.</p>
      </div>
    </div>
  </router-link>

  <!-- CNAE Lists (Account) -->
  <router-link
    to="/account-admin/cnae-lists"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">list</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Lista CNAE</h2>
        </div>
        <p class="text-gray-600 mt-1">Gerencie as listas de CNAE para sua conta.</p>
      </div>
    </div>
  </router-link>

  <!-- User Management (Account) -->
  <router-link
    to="/account-admin/users"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">people</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Usuários</h2>
        </div>
        <p class="text-gray-600 mt-1">Gerencie os usuários da sua conta.</p>
      </div>
    </div>
  </router-link>

  <!-- API Keys (Account) -->
  <router-link
    v-if="canAccessMonitoringConfig"
    to="/account-admin/api-keys"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">vpn_key</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Chaves de API</h2>
        </div>
        <p class="text-gray-600 mt-1">Gerencie chaves de API e o registro de uso.</p>
      </div>
    </div>
  </router-link>

  <router-link
    to="/account-admin/billing"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-amber-100 p-3 rounded-full mr-4 text-amber-700">
        <BaseIcon :size="'lg'">receipt_long</BaseIcon>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Faturamento & Consumo</h2>
        </div>
        <p class="text-gray-600 mt-1">Acompanhe sua assinatura, faturas, carteira de tokens e histórico real de consumo.</p>
      </div>
    </div>
  </router-link>

  <!-- Regulatory Compliance (info + internal-only code-relevance tab) -->
  <router-link
    to="/account-admin/regulatory-compliance"
    class="group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
  >
    <div class="flex items-center">
      <div class="bg-primary-100 p-3 rounded-full mr-4">
        <span class="material-icons text-primary-600 text-3xl">gavel</span>
      </div>
      <div>
        <div class="flex items-center gap-2 mb-1">
          <h2 class="text-2xl font-semibold text-gray-800">Regulação</h2>
        </div>
        <p class="text-gray-600 mt-1">Visualize as regulamentações que seguimos.</p>
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';
import BaseIcon from '@/components/base/BaseIcon.vue';
import { MODULE_ICONS } from '@/constants/icons';
import { hasMonitoringConfigAccess, hasFeatureAccess, isCialInternalUser } from '@/utils/auth';

const authStore = useAuthStore();
const canAccessMonitoringConfig = computed(() => hasMonitoringConfigAccess(authStore.user?.email));
// KYT config mirrors the KYT dashboard gate: CIAL-internal users always, external
// accounts only when the `kyt` feature toggle is granted (see router guard).
const canAccessKytConfig = computed(
  () => isCialInternalUser(authStore.user?.email) || hasFeatureAccess(authStore.user, 'kyt')
);
</script>
